export default __webpack_public_path__ + "static/media/cern-italic.44892b9f.woff2";